export default "/images/upwork.svg?f39a699322a0c6a89acfc64412c199ea";